import React from 'react'
import { Helmet } from 'react-helmet-async'
import { UpcomingInvoiceLayout } from '../../layouts/Billing'

const UpcomingInvoicePage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Upcoming Invoice</title>
      <meta name="description" content="Upcoming invoice page" />
    </Helmet>
    <UpcomingInvoiceLayout />
  </React.Fragment>
)

export default UpcomingInvoicePage
